import { Flex, Box } from "@storyofams/react-ui";
import styled from "styled-components";
import { Button, Text } from "../../../../../components";
import { showToast } from "../../../../../lib";
import { FilePreview } from "./Preview";

const Input = styled(Box)`
  appearance: none;
  opacity: 0;
`;

export const FileInput = ({ files, onChange, ...props }) => {
  const maxSize = 10485760;
  const onFileChange = (newFiles) => {
    if ([...newFiles].find((file) => file.size > maxSize)) {
      showToast("Files are too big.", "error");
      return;
    }

    onChange((files) => [...files, ...newFiles]);
  };

  const clearFile = () => {
    onChange([]);
  };

  return (
    <Box {...props}>
      <Text fontWeight={500} mr="15px">
        Bestanden
      </Text>

      <Flex
        as="label"
        htmlFor="file-input"
        alignItems="center"
        justifyContent="center"
        p={2}
        height={60}
        width="100%"
        border="1px dashed"
        borderColor="grey400"
        borderRadius="md"
        css={{ "&:hover": { cursor: "pointer" } }}
        color="grey600"
      >
        + voeg hier je foto’s of video’s toe
        <Input
          as="input"
          display="none"
          id="file-input"
          name="file-input"
          onChange={(e) => {
            if (e.target.files.length) {
              onFileChange(e.target.files);
            }
          }}
          accept="image/jpeg, image/png, video/*"
          type="file"
          multiple
        />
      </Flex>

      <Box
        display="grid"
        gridTemplateColumns={["repeat(6, 1fr)", "repeat(4, 1fr)"]}
        gridGap={1}
        mt={2}
      >
        {files?.map((file) => (
          <FilePreview
            file={file}
            onRemove={(fileName) =>
              onChange(files?.filter((file) => file.name !== fileName))
            }
          />
        ))}
      </Box>

      {!!files?.length && (
        <Button
          variant="unstyled"
          onClick={clearFile}
          mt={2}
          mx="auto"
          display="block"
          color="grey600"
        >
          Alle bestanden verwijderen
        </Button>
      )}
    </Box>
  );
};
